/* eslint-disable import/no-internal-modules */
/**
 * This is clone of table component of template project plan list view.
 * with few modifications to make it readonly and allow dynamic conditions column to be scrollable.
 * TOOD: have a single configurable table component.
 */
import { Table } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ProjectTemplateSpaceData } from 'data/templates/projects';
import { useSpaceTabularData } from 'data/templates/projects/hooks/use-space-tabular-data';
import { HeaderRow, BodyRow } from '../../plan/table/row';
import { ProjectSpacesTemplateToolBar } from '../../spaces/template-sapces-toolbar';
import { rowClassName, useTableActions } from './table/actions';
import { CustomExpandIcon } from './table/collapse-icon';
import { useProjectTemplateColumns } from './table/columns';

const components = {
  body: {
    row: BodyRow,
  },
  header: {
    row: HeaderRow,
  },
};

const BorderForTable = styled.div`
  border-left: 1px solid var(--border-color);
`;
const TableWrapper = styled.div`
  height: calc(100vh - 240px);
  margin-left: var(--layout-02);
  float: left;
  width: calc(100% - calc(1 * var(--layout-02)));
  position: relative;
  ${BorderForTable} {
    position: absolute;
    height: 100%;
    top: 0;
    left: 374px;
  }

  .ant-table-wrapper {
    max-width: initial;
  }

  .ant-table-cell-fix-left {
    left: 0 !important;
  }

  .ant-table-body {
    overflow: auto !important;
    /* overflow-x: hidden !important; */
    padding-bottom: var(--spacing-02);
  }

  .more__actions {
    display: none;
  }

  .ant-table-row-level-0 {
    font-weight: inherit;
    td:first-child {
      font-weight: var(--font-weight-bold);
    }
  }

  .ant-table table {
    min-width: 100% !important;
    table-layout: inherit !important;
  }

  .dynamic-conditions-column {
    padding: 0 !important;
  }

  td.dynamic-conditions-column {
    border-left: 1px solid var(--border-color);
  }

  th.dynamic-conditions-column {
    border-left: 1px solid var(--border-color);
  }

  .dynamic-template-row {
    cursor: default;
  }
`;

function sortedDataByPrivate(
  projectTemplatSpaceData: ProjectTemplateSpaceData[],
) {
  const privateSpaces = projectTemplatSpaceData.filter(
    (space) => space.type === 'PROJECT_SPACE' && space.private,
  );

  if (privateSpaces[0]) {
    privateSpaces[0].conditionRequired = false;
  }

  const sharedSpaces = projectTemplatSpaceData.filter(
    (space) => space.type === 'PROJECT_SPACE' && !space.private,
  );

  if (sharedSpaces[0]) {
    sharedSpaces[0].conditionRequired = false;
  }

  return [...privateSpaces, ...sharedSpaces];
}

export const ProjectTemplatePlanList: FC<{
  additionalColumns?: any[];
}> = ({ additionalColumns }) => {
  let columns = useProjectTemplateColumns();
  const {
    expandedRowKeys,
    hasClickedExpandCollapse,
    onExpand,
    mode,
    expandCollapse,
  } = useTableActions();

  const _columns = columns.map((column) => ({
    ...column,
    fixed: true,
    editable: false,
    width: column.key === 'duration' ? '89px' : column.width,
    onCell: () => {},
  }));

  if (additionalColumns) {
    columns = [..._columns, ...additionalColumns];
  }

  const _data = useSpaceTabularData();

  const data = sortedDataByPrivate(_data);

  return (
    <>
      <ProjectSpacesTemplateToolBar
        data={data}
        mode={mode}
        expandCollapse={expandCollapse}
      />
      <TableWrapper>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size="small"
          sticky
          scroll={{ x: true, y: 'calc(100vh - 210px)' }}
          expandIcon={CustomExpandIcon}
          components={components}
          expandable={{
            expandedRowKeys: hasClickedExpandCollapse
              ? expandedRowKeys
              : undefined,
            defaultExpandAllRows: true,
            indentSize: 24,
            onExpand,
          }}
          rowClassName={(record) =>
            `${rowClassName(record)} dynamic-template-row`
          }
        />
      </TableWrapper>
    </>
  );
};
